import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { useStaticQuery, graphql } from 'gatsby';

const sdgs = [
  {
    "title": "No Poverty",
    "image": "E_WEB_01.png",
    "url": "https://www.un.org/sustainabledevelopment/poverty/"
  },
  {
    "title": "Zero Hunger",
    "image": "E_WEB_02.png",
    "url": "https://www.un.org/sustainabledevelopment/hunger/"
  },
  {
    "title": "Good Health and Well-being",
    "image": "E_WEB_03.png",
    "url": "https://www.un.org/sustainabledevelopment/health/"
  },
  {
    "title": "Quality Education",
    "image": "E_WEB_04.png",
    "url": "https://www.un.org/sustainabledevelopment/education/"
  },
  {
    "title": "Gender Equality",
    "image": "E_WEB_05.png",
    "url": "https://www.un.org/sustainabledevelopment/gender-equality/"
  },
  {
    "title": "Clean Water and Sanitation",
    "image": "E_WEB_06.png",
    "url": "https://www.un.org/sustainabledevelopment/water-and-sanitation/"
  },
  {
    "title": "Affordable and Clean Energy",
    "image": "E_WEB_07.png",
    "url": "https://www.un.org/sustainabledevelopment/energy/"
  },
  {
    "title": "Decent Work and Economic Growth",
    "image": "E_WEB_08.png",
    "url": "https://www.un.org/sustainabledevelopment/economic-growth/"
  },
  {
    "title": "Industry, Innovation and Infrastructure",
    "image": "E_WEB_09.png",
    "url": "https://www.un.org/sustainabledevelopment/infrastructure-industrialization/"
  },
  {
    "title": "Reduced Inequalities",
    "image": "E_WEB_10.png",
    "url": "https://www.un.org/sustainabledevelopment/inequality/"
  },
  {
    "title": "Sustainable Cities and Communities",
    "image": "E_WEB_11.png",
    "url": "https://www.un.org/sustainabledevelopment/cities/"
  },
  {
    "title": "Responsible Consumption and Production",
    "image": "E_WEB_12.png",
    "url": "https://www.un.org/sustainabledevelopment/sustainable-consumption-production/"
  },
  {
    "title": "Climate Action",
    "image": "E_WEB_13.png",
    "url": "https://www.un.org/sustainabledevelopment/climate-change/"
  },
  {
    "title": "Life Below Water",
    "image": "E_WEB_14.png",
    "url": "https://www.un.org/sustainabledevelopment/oceans/"
  },
  {
    "title": "Life on Land",
    "image": "E_WEB_15.png",
    "url": "https://www.un.org/sustainabledevelopment/biodiversity/"
  },
  {
    "title": "Peace, Justice and Strong Institutions",
    "image": "E_WEB_16.png",
    "url": "https://www.un.org/sustainabledevelopment/peace-justice/"
  },
  {
    "title": "Partnerships for the Goals",
    "image": "E_WEB_17.png",
    "url": "https://www.un.org/sustainabledevelopment/globalpartnerships/"
  }
];

const SDGGroup = ({ children, length }) => {
  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(100px, clamp(100px, 15vw, 200px)))',
    gap: '1.5rem',
    justifyContent: 'center',
    maxWidth: '100%',
  };

  return (
    <div style={gridStyle} className="mx-auto">
        {children}
    </div>
  );
};

const SDGWrapper = ({ children }) => (
  <div className="relative max-w-[200px] max-h-[200px] mx-auto">
    {children}
  </div>
);

const SDG = ({ title }) => {
  const { allFile } = useStaticQuery(graphql`
    query {
      allFile (
        filter: {
          absolutePath: {
            regex: "/\/SDGs\//"
          }
        }
        sort: {
          relativePath: ASC
        }
      ) {
        edges {
          node {
            absolutePath
            childImageSharp {
              gatsbyImageData(
                width: 200
              )
            }
            id
          }
        }
      }
    }
  `);

  const sdg = sdgs.find((sdg) => sdg.title === title);
  const i = sdgs.findIndex(sdg => sdg.title === title);
  sdg.image = allFile.edges[i].node.childImageSharp.gatsbyImageData;

  return (
    <SDGWrapper>
      <a href={sdg.url} target="_blank" rel="noopener noreferrer" className="">
        <GatsbyImage
          image={sdg.image}
          alt={sdg.title}
          objectFit="contain"
          objectPosition="center"
          className="w-full h-full max-w-[200px] max-h-[200px]"
        />
      </a>
    </SDGWrapper>
  );
};

const PrismicSGDs = ({ slice }) => {
  // A responsive grid of square images.
  // The images should be optimally sized even though we don't know how many
  // images there will be, and we don't know the width of the container.

  // Remove null items
  const items = slice.items.filter(item => item.sdg !== null);

  return (
    <SDGGroup length={items.length}>
      {items.map((item, index) => (
        <SDG
          key={index}
          title={item.sdg}
        />
      ))}
    </SDGGroup>
  )
};

export default PrismicSGDs;
